/* Component Dependencies */
var hotelDirectoryResultSummaryTemplate = require('templates/hotelDirectoryResultSummary.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({

  type: 'hotelDirectoryResultSummary',

  template: {
    'hotelDirectoryResultSummary': hotelDirectoryResultSummaryTemplate
  },
  subscribe: {
    'TOGGLE_HOTEL_DIRECTORY_RESULT_SUMMARY': 'toggleHotelDirectoryResultSummary'
  },
  toggleHotelDirectoryResultSummary: function _toggleHotelDirectoryResultSummary(isTileDisplayed){
    var _self=this;
    isTileDisplayed===true?_self.$el.removeClass('l-display-none').addClass('l-display-block'):_self.$el.removeClass('l-display-block').addClass('l-display-none');
  }
  
});
